import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["LotAssignmentModal"], {
    class: "main-wr",
    "is-open": $props.isOpen,
    onClose: $setup.close,
    onConfirm: $setup.confirm
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "text-semi-bold" }, "Confirm Action", -1)
    ]))]),
    description: _withCtx(() => [
      ($setup.props.hasMoreInitialHolds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", null, "There is at least 1 more pending hold request on this lot.", -1),
            _createElementVNode("span", null, "Are you sure you would like to approve this request? All other requests will automatically be declined.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "Are you sure you would like to approve this request?", -1),
            _createElementVNode("span", null, "All other requests will automatically be declined.", -1)
          ]))]))
    ]),
    _: 1
  }, 8, ["is-open"]))
}